type AclStatusName =
  | "Granted"
  | "GrantError"
  | "Pending"
  | "AgentOffline"
  | "Created"
  | "Read"
  | "Published"
  | "Revoking"
  | "Revoked";

type AclStatusConfig = {
  name: AclStatusName;
  grantReady: boolean;
  grantIssued: boolean;
  error: boolean;
  agentOffline: boolean;
  pending: boolean;
  unstable: boolean;
};

type AclStatusKey = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 9 | 10;

type AclStatuses = {
  [K in AclStatusKey]: AclStatusConfig;
};

const statuses: AclStatuses = {
  0: {
    name: "Granted",
    grantReady: false,
    grantIssued: true,
    error: false,
    agentOffline: false,
    pending: false,
    unstable: false,
  },
  1: {
    name: "GrantError",
    grantReady: false,
    grantIssued: false,
    error: true,
    agentOffline: false,
    pending: false,
    unstable: false,
  },
  2: {
    name: "Pending",
    grantReady: false,
    grantIssued: false,
    error: false,
    agentOffline: false,
    pending: true,
    unstable: true,
  },
  3: {
    name: "AgentOffline",
    grantReady: false,
    grantIssued: false,
    error: false,
    agentOffline: true,
    pending: false,
    unstable: false,
  },
  4: {
    name: "Created",
    grantReady: true,
    grantIssued: false,
    error: false,
    agentOffline: false,
    pending: false,
    unstable: false,
  },
  5: {
    name: "Read",
    grantReady: false,
    grantIssued: true,
    error: false,
    agentOffline: false,
    pending: false,
    unstable: false,
  },
  6: {
    name: "Published",
    grantReady: false,
    grantIssued: true,
    error: false,
    agentOffline: false,
    pending: false,
    unstable: true,
  },
  8: {
    name: "Revoking",
    grantReady: false,
    grantIssued: true,
    error: false,
    agentOffline: false,
    pending: false,
    unstable: true,
  },
  9: {
    name: "Revoked",
    grantReady: true,
    grantIssued: false,
    error: false,
    agentOffline: false,
    pending: false,
    unstable: false,
  },
  10: {
    name: "Revoked",
    grantReady: false,
    grantIssued: false,
    error: true,
    agentOffline: false,
    pending: false,
    unstable: false,
  },
};

export function getAclStatus(statusCode: AclStatusKey): AclStatusConfig;
export function getAclStatus(statusCode: number): AclStatusConfig | undefined;
export function getAclStatus(statusCode: number): AclStatusConfig | undefined {
  return statuses[statusCode as AclStatusKey];
}

// Export types for use in other files
export type { AclStatusConfig, AclStatusKey };
